export default {
  // menu layout
  dashboard: "ภาพรวมงาน",
  design: "ออกแบบ",
  document: "วิธีการใช้งาน",
  information: "ข้อมูล",
  profile: "ข้อมูลส่วนตัว",
  logout: "ออกจากระบบ",
  bandname: "การไฟฟ้านครหลวง",
  user: "จัดการผู้ใช้",
  // design
  clear: "ล้าง",
  project: "การออกแบบระบบไฟฟ้า",
  proj: "โปรเจ็ค",
  projReport: "รายงานโปรเจ็ค",
  createProject: "สร้างโปรเจ็ค",
  assign: "มอบหมาย",
  workOrderNo: "หมายเลขงาน",
  customerName: "ชื่อลูกค้า",
  createDate: "วันที่สร้าง",
  status: "สถานะ",
  confirm: "ยืนยัน",
  waitting: "รอดำเนินการ",
  inProcess: "อยู่ระหว่างดำเนินการ",
  complete: "สำเร็จ",
  all: "ทั้งหมด",
  search: "ค้นหา",
  rowPerPage: "แถวต่อหน้า",
  noProject: "ไม่มีโปรเจ็ค !!",
  pleaseCreateProject: "โปรดสร้างโปรเจ็ค สำหรับออกแบบระบบไฟฟ้า",
  required: "ต้องกรอก",
  department: "เขตการไฟฟ้า",
  detail: "รายละเอียด",
  customerAddress: "ที่อยู่ลูกค้า",
  cancel: "ยกเลิก",
  update: "อัพเดท",
  create: "สร้าง",
  save: "บันทึก",
  donotsave: "ไม่บันทึก",
  edit: "แก้ไข",
  summary: "สรุป",
  chooseEquip: "",
  appearance: "ลักษณะ",
  sendEmailReport: "ส่งอีเมลรายงาน",
  startDate: "วันเริ่มต้น",
  endDate: "วันสิ้นสุด",
  //equip electric
  pole: "เสา",
  cable: "สายไฟ",
  relay: "รีเลย์",
  transformer: "หม้อแปลงไฟฟ้า",
  switch: "สวิตซ์",
  meter: "มิเตอร์",
  riserTransformer: "Riser Transformer",
  cableType: "ประเภทสายไฟ",
  workFunction: "ฟังก์ชันการทำงาน",
  comment: "ความคิดเห็น",
  images: "รูปถ่าย",
  chooseImage: "เลือกรูปภาพ",
  lamp: "โคมไฟ",
  size: "ขนาด",
  ground: "สายดิน",
  type: "ประเภท",
  heigh: "ความสูง",
  metre: "เมตร",
  // electrict mapservice
  overhead: "กลุ่มระบบไฟฟ้าบนดิน",
  underground: "กลุ่มระบบไฟฟ้าใต้ดิน",
  groupX: "ระบบไฟฟ้าบนดิน",
  groupY: "ระบบไฟฟ้าใต้ดิน",
  groupZ: "ไฟเบอร์ออฟติก",
  groupA: "ระบบไฟฟ้าสาธารณะ",
  Lowvoltagemeter: "มิเตอร์ไฟฟ้าแรงต่ำ",
  HighTensionMeter: "มิเตอร์ไฟฟ้าแรงสูง",
  GroupMeter: "มิเตอร์กลุ่ม",
  Transformer: "Transformer",
  Switch: "Switch",
  Fuse: "Fuse",
  Capacitor: "Capacitor",
  CircuitBreaker: "เซอร์กิตเบรคเกอร์",
  SLInlineEquipment: "อุปกรณ์ประกอบสายไฟฟ้าสาธารณะ",
  LightningArrestor: "Lightning Arrestor",
  InlineEquipment: "อุปกรณ์ประกอบสาย",
  Ground: "Ground",
  SpanGuy: "SpanGuy",
  Pole: "เสาไฟฟ้า",
  MeterLine: "Meter Line",
  Meter_Link: "Meter Link",
  OHHVConductor: "สายไฟฟ้าอากาศแรงสูง",
  OHMVConductor: "สายไฟฟ้าอากาศแรงกลาง",
  OHLVConductor: "สายไฟฟ้าอากาศแรงต่ำ",
  OHLVConductorUnderBuilding: "สายไฟฟ้าแรงต่ำใต้อาคาร",
  ManHole: "Manhole",
  Splice: "Splice",
  CCTV: "CCTV",
  FiberOpticCable: "สายสื่อสาร",
  OHSLConductor: "สายอากาศไฟฟ้าสาธารณะ",
  Streetlight: "ดวงโคมไฟฟ้าสาธารณะ",
  StreetlightControl: "อุปกรณ์ควบคุมไฟฟ้าสาธารณะ",
  UGMVConductor: "สายไฟฟ้าใต้ดินแรงกลาง",
  UGHVConductor: "สายไฟฟ้าใต้ดินแรงสูง",
  UGLVConductor: "สายไฟฟ้าใต้ดินแรงต่ำ",
  DuctBank: "แนวท่อร้อยสายใต้ดิน",
  UGSLConductor: "สายใต้ดินไฟฟ้าสาธารณะ",
  FiberOpticCable_MEA: "Fiber",
  // administrative boundary
  administrativeBoundary: "ขอบเขตการปกครอง",
  province: "จังหวัด",
  amphoe: "อำเภอ",
  tambon: "ตำบล",
  municipal: "เทศบาล",
  housing: "หมู่บ้าน",
  // basemap
  basemap: "แผนที่ฐาน",
  meaTile: "แผนที่ Landbase",
  nostra: "แผนที่ NOSTRA",
  meaOrtho: "ภาพถ่ายทางอากาศ",
  // print
  layout: "แนวกระดาษ",
  landscape: "แนวนอน",
  portrait: "แนวตั้ง",
  paperSize: "ขนาดกระดาษ",
  scale: "มาตราส่วน",
  other: "อื่นๆ",
  compass: "สัญลักษณ์ทิศ",
  overview: "แผนที่ภาพรวม",
  grayscale: "ขาวดำ",
  estimator: "ผู้ประมาณการ",
  examiner: "ผู้ตรวจ",
  head: "หัวหน้าแผนก",
  divisionDirector: "ผู้อำนวยการกอง",
  districtDirector: "ผู้อำนวยการฝ่าย/เขต",
  print: "พิมพ์",
  preview: "ดูตัวอย่าง",
  //user
  name: "ชื่อ",
  lastname: "นามสกุล",
  organization: "องค์กร",
  address: "ที่อยู่",
  phone: "โทรศัพท์",
  register: "สมัคร",
  back: "กลับ",
  district: "อำเภอ",
  subdistrict: "ตำบล",
  city: "จังหวัด",
  country: "ประเทศ",
  zipcode: "รหัสไปรษณีย์",
  sameemail: "อีเมลนี้ถูกใช้งานแล้ว",
  registersuccess:
    "สมัครสมาชิกเรียบร้อยแล้ว กรุณาตรวจสอบอีเมลของคุณเพื่อยืนยันบัญชี",
  next: "ถัดไป",
  email: "อีเมล",
  password: "รหัสผ่าน",
  confirmpassword: "ยืนยันรหัสผ่าน",
  passwordnotmatch: "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน",
  personalinfo: "ข้อมูลส่วนตัว",
  account: "บัญชี",
  createAccessService: "สร้างบัญชีเพื่อใช้บริการข้อมูลการไฟฟ้า",
  alreadyaccount: "มีบัญชีผู้ใช้งานแล้ว",
  signin: "เข้าสู่ระบบ",
  bySignin: "เมื่อลงชื่อเข้าใช้ระบบคุณได้ยอมรับ",
  and: "และ",
  privacyPolicy: "นโยบายความเป็นส่วนตัว",
  termCondition: "ข้อกำหนดและเงื่อนไข",
  getmorething: "รับสิ่งต่าง ๆ มากขึ้นเพียงลงชื่อเข้าใช้",
  donthaveaccount: "ไม่มีบัญชีผู้ใช้งานใช่ไหม",
  createhere: "สร้างบัญชีที่นี่",
  rememberme: "จดจำฉัน",
  forgotPassword: "ลืมรหัสผ่าน",
  // confirm save
  confirmSavePrimary: "คุณต้องการบันทึกการเปลี่ยนแปลงที่ทำกับ",
  confirmSaveSecondary: "การเปลี่ยนแปลงของคุณจะหายไปหากคุณไม่บันทึกไว้",
  //information
  gotohomepage: "ไปที่หน้าหลัก",
  askforusage: "สอบถามการใช้งาน",
  mealist: "รายชื่อผู้ติดตั้งระบบไฟฟ้าภายในที่ขึ้นทะเบียนกับกฟน",
  lastUpdate: "อัพเดทล่าสุด",
  // util
  duration: "ช่วงเวลา",
  custom: "กำหนดเอง",
  month: "เดือน",
  monthly: "รายเดือน",
  quarter: "ไตรมาส",
  quarterly: "รายไตรมาส",
  year: "ปี",
  yearly: "รายปี",
  noData: "ไม่มีข้อมูล",
  landmarkPoint: "สถานที่",
  electricUser: "ข้อมูลผู้ใช้ไฟ",
};
